import { Anchor, Card } from '@vtex/admin-ui'
import { TextInput } from '@vtex/admin-ui-form'
import { useState } from 'react'
import { useIntl } from 'react-intl'
import { SettingsProps } from '../../../hooks/useGenericComponent'
import { ExamplesCard } from './cards/ExamplesCard'
import { FunctionsCard } from './cards/FunctionsCard'
import { OperationsCard } from './cards/OperationsCard'
import { VariablesCard } from './cards/VariablesCard'
import { NAME } from './constants'
import { messages } from './messages'
import { styles } from './styles'

export function FormulaEditor(props: SettingsProps) {
  const { state } = props
  const { $t } = useIntl()

  const [placeholder, setPlaceholder] = useState<string | undefined>()

  return (
    <div>
      <TextInput
        name={NAME}
        state={state}
        label={$t(messages.editor.label)}
        helpText={$t(messages.editor.helpText, {
          a: (content) => (
            <Anchor target="_blank" href={$t(messages.editor.moreInformation)}>
              {content}
            </Anchor>
          ),
        })}
        placeholder={placeholder}
      />
      <Card className={styles.card.container}>
        <ExamplesCard
          form={state}
          onMouseEnter={(example) => setPlaceholder(example)}
          onMouseLeave={() => setPlaceholder('')}
        />
        <VariablesCard />
        <OperationsCard />
        <FunctionsCard />
      </Card>
    </div>
  )
}
